export const PAYMENT_IDEMPOTENCY_KEY_HEADER = "Idempotency-Key";

/** Creates a stable key for one checkout attempt. */
export function createPaymentIdempotencyKey(): string {
  if (
    typeof globalThis.crypto !== "undefined" &&
    typeof globalThis.crypto.randomUUID === "function"
  ) {
    return globalThis.crypto.randomUUID();
  }

  return `checkout-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

/** Reads and validates the idempotency key sent by a payment client. */
export function readPaymentIdempotencyKey(
  request: Request,
): string | null {
  const value = request.headers.get(PAYMENT_IDEMPOTENCY_KEY_HEADER)?.trim();

  if (!value || value.length < 16 || value.length > 255) {
    return null;
  }

  return value;
}
